export const COMMENT = 'Comment';
export const COMMENT_LIKE = 'Comment Like';
export const COMMENT_DELETE = 'Comment Delete';
export const COMMENT_REPORT = 'Comment Report';
export const VIEW_REPLIES = 'View replies';

export const CHARACTER_LENGTH = 'Character length';
export const CONTENT_ID = 'Content ID';
export const COMMUNITY_ID = 'Community ID';
export const COMMENT_TYPE = 'Type of comment';
export const CONTENT_TYPE = 'Type of content';
export const EDIT_COMMENT = 'Edit comment';
export const NUMBER_OF_MENTIONS = '# of mentions';
export const NUMBER_OF_REPLIES = '# of replies';
export const MENTIONED_USER_IDS = 'User IDs of mentions';
export const SHOWING_REPLIES = 'Showing replies';
